import { Component, OnInit } from '@angular/core';
import { NavigationBase } from '../../navigation-base';

/**
 * Handles the roles management navigation component
 */
@Component({
  selector: 'roles-management-navigation',
  templateUrl: './roles-management-navigation.component.html'
})
export class RolesManagementNavigationComponent extends NavigationBase implements OnInit {
  /**
   * NgOnInit
   */
  ngOnInit(): void {
    super.ngOnInit();
  }

  /**
   * Triggers the specified action.
   * @param action The action to trigger.
   */
  triggerAction(action: string) {
    this.eventBus.broadcastEvent(action);

    // You can add further comments or explanations if needed.
  }
}
